import React from "react";
import { Typography } from "@mui/material";

export const NoResultsFound = () => {
  return (
    <Typography
      sx={{
        fontSize: "10px",
        fontStyle: "italic",
        color: "text.secondary",
      }}
      data-test-id="gs-no-results"
    >
      No results found
    </Typography>
  );
};
